import type { WiwState } from '@/store';

export const getSelectedDefinitionId = (state: WiwState): number | undefined =>
  state.reporting.customReportBuilder.selectedDefinitionId;
